export interface ITag {
  id: number;
  name: string;
  organization: number;
}

/**
 * Raw shape returned by `GET api/tags/`. The API currently expands `organization`
 * into a full object; we only keep its `id`. Once the API is made consistent and
 * returns a bare id, the union collapses to `number` with no mapper change needed.
 */
export interface ITagApi {
  id: number;
  name: string;
  organization: number | { id: number };
}

export interface ITagCreateRequest {
  name: string;
  organization: number;
}

export const EMPTY_TAGS: ITag[] = [];
